import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dataAddActivityAsync, dataUpdateActivityAsync, dataDeleteActivityAsync, 
  dataLoadActivitiesAsync, dataLoadActivitiesFilterAsync } from '../utils/dataApi';
import Debug from '../utils/logger';

const debug = new Debug('activitiesSlice');
debug.enabled = true;
debug.actions = { 
  addActivityAsync: true, updateActivityAsync: true, deleteActivityAsync: true, 
  fetchActivities: true, 
  addActivityAsync_fulfilled: true, 
  updateActivityAsync_fulfilled: true, 
  deleteActivityAsync_fulfilled: true,
};

export const addActivityAsync = createAsyncThunk(
  'activities/addActivity',
  async (activity, { dispatch, rejectWithValue }) => {
    try {
      if(activity.coreId) {
        activity.coreId = activity.coreId.toLowerCase();
      }
      const response = await dataAddActivityAsync(activity);
      if(response.error) {
        debug.error('addActivityAsync', response.error);
        return rejectWithValue(response);
      }
      dispatch(setShallLoadActivity(true));
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateActivityAsync = createAsyncThunk(
  'activities/updateActivity',
  async (activity, { dispatch, rejectWithValue }) => {
    try {
      if(activity.coreId) {
        activity.coreId = activity.coreId.toLowerCase();
      }
      const response = await dataUpdateActivityAsync(activity);
      if(response.error) {
        debug.error('updateActivityAsync', response.error);
        return rejectWithValue(response);
      }
      dispatch(setShallLoadActivity(true));
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteActivityAsync = createAsyncThunk(
  'activities/deleteActivity',
  async (id, { dispatch, rejectWithValue }) => {
    try {
      let response = await dataDeleteActivityAsync(id);
      if(response.error) {
        debug.error('deleteActivityAsync', response.error);
        return rejectWithValue(response);
      }
      dispatch(setShallLoadActivity(true));
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchActivities = createAsyncThunk('activities/fetchActivities', async (coreId = null) => {
  const response = await dataLoadActivitiesAsync(coreId? coreId.toLowerCase() : null);
  return response;
});

export const fetchActivitiesListUsersFilterUi = createAsyncThunk('activities/fetchActivitiesListUsers', async (coreIds, mngrsIds) => {
  let sendCoreIds = coreIds? coreIds.map((coreId) => coreId.toLowerCase()) : [];
  //let sendMngrsIds = mngrsIds? mngrsIds.map((mngrId) => mngrId.toLowerCase()) : [];
  const response = await dataLoadActivitiesAsync();
  // const response = await dataLoadActivitiesFilterAsync(sendCoreIds)
  const coreIdsObj = sendCoreIds? sendCoreIds.reduce((acc, coreId) => { acc[coreId.toLowerCase()] = true; return acc; }, {}) : {};
  let ret = response.filter((activity) => coreIdsObj[activity.coreId]);
  return ret;
});

export const fetchActivitiesListUsersFilterSrv = createAsyncThunk('activities/fetchActivitiesListUsers', async (mngrsIds) => {
  debug.log('fetchActivitiesListUsersFilterSrv', mngrsIds);
  //let sendCoreIds = coreIds? coreIds.map((coreId) => coreId.toLowerCase()) : [];
  let sendMngrsIds = mngrsIds? mngrsIds.map((mngrId) => mngrId.toLowerCase()) : [];
  const response = await dataLoadActivitiesFilterAsync([], sendMngrsIds);
  // const response = await dataLoadActivitiesFilterAsync(sendCoreIds)
  //const coreIdsObj = sendCoreIds? sendCoreIds.reduce((acc, coreId) => { acc[coreId.toLowerCase()] = true; return acc; }, {}) : {};
  let ret = response;
  return ret;
});

export const fetchActivitiesListUsers = fetchActivitiesListUsersFilterSrv;

const initialState = {
  shallLoadActivity: true,
  activities: [],
  selectedActivity: null,
  status: 'idle',
  error: null,
};

export const activitiesSlice = createSlice({
  name: 'activities',
  initialState,
  reducers: {
    setShallLoadActivity: (state, action) => {
      state.shallLoadActivity = action.payload;
    },
    selectActivity: (state, action) => {
      state.selectedActivity = action.payload;
    },
    clearSelectedActivity: (state) => {
      state.selectedActivity = null;
    },
    clearActivities: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addActivityAsync.fulfilled, (state, action) => {
        if(action.payload.error) {
          state.status = 'failed';
          state.error = action.payload.error;
          debug.warn('addActivityAsync_fulfilled', action.payload.error);
          return;
        }
        //state.activities.push(action.payload);
        state.status = 'succeeded';
      })
      .addCase(updateActivityAsync.fulfilled, (state, action) => {
        if(action.payload.error) {
          state.status = 'failed';
          state.error = action.payload.error;
          debug.warn('updateActivityAsync_fulfilled', action.payload.error);
          return;
        }
        //const { id, coreId, date, activityId, hours, comment, group, _key } = action.payload;
        //const index = state.activities.findIndex(act => act.id === id);
        //if (index !== -1) {
          //state.activities[index] = { id, coreId, date, activityId, hours, comment, group, _key };
        //}
        state.status = 'succeeded';
      })
      .addCase(deleteActivityAsync.fulfilled, (state, action) => {
        if(action.payload.error) {
          state.status = 'failed';
          state.error = action.payload.error;
          debug.warn('deleteActivityAsync_fulfilled', action.payload.error);
          return;
        }
        //state.activities = state.activities.filter((activity) => activity.id !== action.payload);
        state.status = 'succeeded';
      })
      .addCase(addActivityAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateActivityAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteActivityAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(addActivityAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(updateActivityAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(deleteActivityAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchActivities.fulfilled, (state, action) => {
        if(action.payload.error) {
          state.status = 'failed';
          state.error = action.payload.error;
          debug.warn('fetchActivities.fulfilled', action.payload.error);
          return;
        }
        state.activities = action.payload;
        state.status = 'succeeded';
      })
      .addCase(fetchActivities.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchActivities.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      /*
      .addCase(fetchActivitiesListUsers.fulfilled, (state, action) => {
        if(action.payload.error) {
          state.status = 'failed';
          state.error = action.payload.error;
          debug.warn('fetchActivitiesListUsers.fulfilled', action.payload.error);
          return;
        }
        state.activities = action.payload;
        state.status = 'succeeded';
      })
      .addCase(fetchActivitiesListUsers.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchActivitiesListUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
        */
      .addCase(fetchActivitiesListUsersFilterSrv.fulfilled, (state, action) => {
        if(action.payload.error) {
          state.status = 'failed';
          state.error = action.payload.error;
          debug.warn('fetchActivitiesListUsersFilterSrv.fulfilled', action.payload.error);
          return;
        }
        state.activities = action.payload;
        state.status = 'succeeded';
      })
      .addCase(fetchActivitiesListUsersFilterSrv.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchActivitiesListUsersFilterSrv.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      ; //fetchActivitiesListUsersFilterSrv
  },
});

export const { selectActivity, clearSelectedActivity, setShallLoadActivity, clearActivities } = activitiesSlice.actions;

export default activitiesSlice.reducer;


